export function dhms(t) {
  const diffInSeconds = Math.floor(t / 1000);
  const days = Math.floor(diffInSeconds / 24 / 60 / 60);
  const hours = Math.floor(diffInSeconds / 60 / 60) - days * 24;
  const minutes = Math.floor(diffInSeconds / 60) - days * 24 * 60 - hours * 60;
  const seconds =
    diffInSeconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

  return {days, hours, minutes, seconds};
}



// WEBPACK FOOTER //
// ./utils/timers.js